module.exports = {
    apiBaseDomain: process.env.REACT_APP_API_BASE_DOMAIN,
    apiBaseDomainTrails: process.env.REACT_APP_TRAILS_API_BASE_DOMAIN,
    signInDomain: process.env.REACT_APP_SIGN_IN_URL,
};
